@file:OptIn(InternalResourceApi::class)

package subastia.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/subastia.composeapp.generated.resources/"

internal val Res.string.profile_item_settings: StringResource by lazy {
      StringResource("string:profile_item_settings", "profile_item_settings", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4357, 49),
      ))
    }

internal val Res.string.profile_section_account: StringResource by lazy {
      StringResource("string:profile_section_account", "profile_section_account", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4407, 39),
      ))
    }

internal val Res.string.profile_section_general: StringResource by lazy {
      StringResource("string:profile_section_general", "profile_section_general", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4447, 43),
      ))
    }

internal val Res.string.profile_version: StringResource by lazy {
      StringResource("string:profile_version", "profile_version", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4491, 43),
      ))
    }

internal val Res.string.search_placeholder: StringResource by lazy {
      StringResource("string:search_placeholder", "search_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4535, 38),
      ))
    }

internal val Res.string.search_saved_message: StringResource by lazy {
      StringResource("string:search_saved_message", "search_saved_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4574, 72),
      ))
    }

internal val Res.string.section_asset_details: StringResource by lazy {
      StringResource("string:section_asset_details", "section_asset_details", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4647, 53),
      ))
    }

internal val Res.string.section_auction_data: StringResource by lazy {
      StringResource("string:section_auction_data", "section_auction_data", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4701, 56),
      ))
    }

internal val Res.string.section_authority: StringResource by lazy {
      StringResource("string:section_authority", "section_authority", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4758, 49),
      ))
    }

internal val Res.string.section_description: StringResource by lazy {
      StringResource("string:section_description", "section_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4808, 43),
      ))
    }

internal val Res.string.section_economic: StringResource by lazy {
      StringResource("string:section_economic", "section_economic", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4852, 40),
      ))
    }

internal val Res.string.sort_newest: StringResource by lazy {
      StringResource("string:sort_newest", "sort_newest", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4893, 39),
      ))
    }

internal val Res.string.sort_oldest: StringResource by lazy {
      StringResource("string:sort_oldest", "sort_oldest", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4933, 39),
      ))
    }

internal val Res.string.text_claimed_amount_value: StringResource by lazy {
      StringResource("string:text_claimed_amount_value", "text_claimed_amount_value", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4973, 53),
      ))
    }

internal val Res.string.text_coming_soon_saved_searches: StringResource by lazy {
      StringResource("string:text_coming_soon_saved_searches", "text_coming_soon_saved_searches", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5027, 87),
      ))
    }

internal val Res.string.text_create_account: StringResource by lazy {
      StringResource("string:text_create_account", "text_create_account", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5115, 51),
      ))
    }

internal val Res.string.text_have_account_login: StringResource by lazy {
      StringResource("string:text_have_account_login", "text_have_account_login", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5167, 79),
      ))
    }

internal val Res.string.text_no_auctions_found: StringResource by lazy {
      StringResource("string:text_no_auctions_found", "text_no_auctions_found", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5247, 66),
      ))
    }

internal val Res.string.text_or: StringResource by lazy {
      StringResource("string:text_or", "text_or", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5314, 19),
      ))
    }

internal val Res.string.title_auction_detail: StringResource by lazy {
      StringResource("string:title_auction_detail", "title_auction_detail", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5334, 52),
      ))
    }

internal val Res.string.title_auctions: StringResource by lazy {
      StringResource("string:title_auctions", "title_auctions", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5387, 34),
      ))
    }

internal val Res.string.title_create_account: StringResource by lazy {
      StringResource("string:title_create_account", "title_create_account", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5422, 44),
      ))
    }

internal val Res.string.title_error: StringResource by lazy {
      StringResource("string:title_error", "title_error", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5467, 27),
      ))
    }

internal val Res.string.title_favorites: StringResource by lazy {
      StringResource("string:title_favorites", "title_favorites", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5495, 43),
      ))
    }

internal val Res.string.title_filter_screen: StringResource by lazy {
      StringResource("string:title_filter_screen", "title_filter_screen", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5539, 51),
      ))
    }

internal val Res.string.title_onboarding_province: StringResource by lazy {
      StringResource("string:title_onboarding_province", "title_onboarding_province", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5591, 61),
      ))
    }

internal val Res.string.title_onboarding_type: StringResource by lazy {
      StringResource("string:title_onboarding_type", "title_onboarding_type", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5653, 69),
      ))
    }

internal val Res.string.title_saved_searches: StringResource by lazy {
      StringResource("string:title_saved_searches", "title_saved_searches", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5723, 56),
      ))
    }

internal val Res.string.title_welcome_back: StringResource by lazy {
      StringResource("string:title_welcome_back", "title_welcome_back", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5780, 54),
      ))
    }

internal val Res.string.welcome_user: StringResource by lazy {
      StringResource("string:welcome_user", "welcome_user", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5835, 40),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString1Resources(map: MutableMap<String, StringResource>) {
  map.put("profile_item_settings", Res.string.profile_item_settings)
  map.put("profile_section_account", Res.string.profile_section_account)
  map.put("profile_section_general", Res.string.profile_section_general)
  map.put("profile_version", Res.string.profile_version)
  map.put("search_placeholder", Res.string.search_placeholder)
  map.put("search_saved_message", Res.string.search_saved_message)
  map.put("section_asset_details", Res.string.section_asset_details)
  map.put("section_auction_data", Res.string.section_auction_data)
  map.put("section_authority", Res.string.section_authority)
  map.put("section_description", Res.string.section_description)
  map.put("section_economic", Res.string.section_economic)
  map.put("sort_newest", Res.string.sort_newest)
  map.put("sort_oldest", Res.string.sort_oldest)
  map.put("text_claimed_amount_value", Res.string.text_claimed_amount_value)
  map.put("text_coming_soon_saved_searches", Res.string.text_coming_soon_saved_searches)
  map.put("text_create_account", Res.string.text_create_account)
  map.put("text_have_account_login", Res.string.text_have_account_login)
  map.put("text_no_auctions_found", Res.string.text_no_auctions_found)
  map.put("text_or", Res.string.text_or)
  map.put("title_auction_detail", Res.string.title_auction_detail)
  map.put("title_auctions", Res.string.title_auctions)
  map.put("title_create_account", Res.string.title_create_account)
  map.put("title_error", Res.string.title_error)
  map.put("title_favorites", Res.string.title_favorites)
  map.put("title_filter_screen", Res.string.title_filter_screen)
  map.put("title_onboarding_province", Res.string.title_onboarding_province)
  map.put("title_onboarding_type", Res.string.title_onboarding_type)
  map.put("title_saved_searches", Res.string.title_saved_searches)
  map.put("title_welcome_back", Res.string.title_welcome_back)
  map.put("welcome_user", Res.string.welcome_user)
}
